import {makeAutoObservable} from 'mobx'
export default class ApplicationStore{
    constructor() {
        this._applications = []
        makeAutoObservable(this)
    }
    setApplications(applications){
        this._applications = applications
    }

    getApplications(){
        return this._applications
    }

}